import { useNavigate, useLocation } from 'react-router-dom';
import { Settings } from 'lucide-react';

/**
 * AdminShortcut - A floating button that appears on all screens for admin users
 * Provides quick access to the admin dashboard from anywhere in the app
 */
const AdminShortcut = ({ user }) => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Don't show if not an admin or already on admin page
  if (!user?.is_admin || location.pathname === '/admin') {
    return null;
  }
  
  return (
    <button
      data-testid="admin-shortcut-btn"
      onClick={() => navigate('/admin')}
      className="fixed bottom-24 right-4 z-50 bg-red-600 hover:bg-red-700 text-white 
                 px-4 py-3 rounded-full shadow-xl border-3 border-yellow-400 
                 transition-all duration-200 hover:scale-110 active:scale-95
                 flex items-center gap-2 font-bold text-sm"
      title="Admin Dashboard"
      style={{ boxShadow: '0 4px 20px rgba(0,0,0,0.4)' }}
    >
      <Settings className="w-5 h-5" />
      <span>ADMIN</span>
    </button>
  );
};

export default AdminShortcut;
